import { createContext } from 'react';
const ToastsContext = createContext({
    push() {
        throw 'must be provided';
    },
});
export default ToastsContext;
